<button
  lyceoButton
  type="submit"
  [disabled]="form().invalid() || !form().dirty() || form().submitting()"
>
  @if (form().submitting()) {
    <fa-icon [icon]="faSpinner" animation="spin" />
  }
  <ng-content />
</button>
